<template>
  <v-dialog v-model="isAvailabilityDialogVisible" fullscreen transition="dialog-bottom-transition" :overlay="false">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="innerCloseModal" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('private_modal_availabilities_modify_title') }}</v-toolbar-title>
      </v-toolbar>

      <v-layout row wrap class="pa-2">
        <v-flex xs12>
          <v-alert outline color="info" icon="priority_high" :value="true" v-if="hasAggressiveRecolocation">
            {{ $t('private_modal_availabilities_modify_date_tip_aggressive') }}
          </v-alert>
          <v-alert outline color="info" icon="priority_high" :value="true" v-else>
            {{ $t('private_modal_availabilities_modify_date_tip') }}
          </v-alert>
        </v-flex></v-layout
      >

      <v-stepper v-model="activeStep" vertical>
        <v-stepper-step step="1" edit-icon="mdi-flash-outline" :complete="activeStep > 1">
          {{ $t('private_availability_modal_actions_section') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-container class="pa-2">
            <v-layout v-if="isSensored" row wrap>
              <v-flex xs12 style="text-align: center">
                <el-radio-group v-model="actionAvailability">
                  <el-radio-button label="add">{{ $t('private_modal_availabilities_modify_button_add') }}</el-radio-button>
                  <el-radio-button label="sub">{{ $t('private_modal_availabilities_modify_button_del') }}</el-radio-button>
                </el-radio-group>
              </v-flex>
            </v-layout>
            <v-layout v-else row wrap>
              <v-flex xs12 align-content-center>
                <span v-html="$t('private_availability_modal_actions_section_sensorless_explanation')"> </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-btn class="btn btn-default btn-fill btn-wd btn-back capitalize" color="grey lighten-1" disabled v-html="$t('private_global.button.back')"></v-btn>

          <v-btn @click="activeStep = 2" color="primary" class="capitalize" v-html="$t('private_global.button.next')"></v-btn>
        </v-stepper-content>

        <v-stepper-step step="2" edit-icon="mdi-calendar" :complete="activeStep > 2" :rules="[() => isValidStep2]">
          <v-layout row>
            <label style="margin-top:14px">
              {{ $t('private_availability_modal_dates_section') }}
            </label>
            <v-tooltip v-model="showCalendarTooltip" max-width="250" bottom>
              <v-btn slot="activator" @click="showCalendarTooltip = !showCalendarTooltip" icon>
                <v-icon color="grey lighten-1">help</v-icon>
              </v-btn>
              <span v-html="$t('availability_calendar_tooltip')"></span>
            </v-tooltip>
          </v-layout>
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-container fluid class="pa-2">
            <v-layout row wrap>
              <!-- <v-flex xs12 sm2>
                <v-switch v-model="isUsingAdvancedDatesMode" color="primary" :label="$t('private_availability_modal_turn_on_advaced_mode')"> </v-switch>
              </v-flex> -->

              <v-flex xs12 sm12 align-self-center text-xs-left>
                <template v-if="!isUsingAdvancedDatesMode">
                  <el-date-picker
                    v-model="datesAvailabilityBasic"
                    type="datetimerange"
                    range-separator="-"
                    :start-placeholder="this.$i18n.t('fromLabel')"
                    :end-placeholder="$t('toLabel')"
                    :size="'large'"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    :format="store.state.dateFormatTime"
                    :class="{ 'el-xs-size': $vuetify.breakpoint.xs, 'el-big-size': !$vuetify.breakpoint.xs }"
                    popper-class="standard-font-family"
                  >
                  </el-date-picker>
                </template>
                <template v-else>
                  <vuetify-from-to-date-selector :lang-selected="langSelected" :allowSameStartEnd="true" :allowNullEnd="false" @on-dates-selected="datesSelected" />
                </template>
              </v-flex>
            </v-layout>

            <v-layout row v-if="isUsingAdvancedDatesMode">
              <v-flex xs12>
                <schedule-configurator @on-weekday-changed="onWeekdayChanged" ref="scheduleConfigurator"></schedule-configurator>
              </v-flex>
            </v-layout>
          </v-container>

          <v-btn class="btn btn-default btn-fill btn-wd btn-back capitalize" color="grey lighten-1" @click="activeStep = 1" v-html="$t('private_global.button.back')"></v-btn>

          <v-btn @click="validateSecondStep" color="primary" class="capitalize" v-html="$t('private_global.button.next')"></v-btn>
        </v-stepper-content>

        <v-stepper-step step="3" edit-icon="mdi-car-side" :complete="activeStep > 2" :rules="[() => isValidStep3]">
          <span v-if="isSensored">
            {{ $t('private_availability_modal_spots_section_sensored') }}
          </span>
          <span v-else>
            {{ $t('private_availability_modal_spots_section_sensorless') }}
          </span>
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-container fluid class="pa-2">
            <v-layout v-if="isSensored">
              <v-flex xs12>
                <spots-multiple-select @on-spots-changed="onSpotsChanged" ref="spotsMultipleSelect"></spots-multiple-select>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex xs12>
                <v-alert color="info" outline>
                  {{ $t('private_modal_availabilities_modify_spot_tip') }}
                </v-alert>
                <label v-html="$t('private_modal_availabilities_modify_spots_amount', { spotsAmount: store.state.parkingTotalSpots })"></label>
                <el-input-number v-model="spotsAmountSensorless" :min="0" :max="store.state.parkingTotalSpots"></el-input-number>
              </v-flex>
            </v-layout>
          </v-container>

          <v-btn class="btn btn-default btn-fill btn-wd btn-back capitalize" color="grey lighten-1" @click="activeStep = 2" v-html="$t('private_global.button.back')"></v-btn>

          <v-btn @click="validateThirdStep" color="primary" class="capitalize" v-html="$t('private_global.button.next')"></v-btn>
        </v-stepper-content>

        <v-stepper-step step="4" edit-icon="mdi-check" :complete="activeStep > 3">
          {{ $t('private_availability_modal_summary_section') }}
        </v-stepper-step>
        <v-stepper-content step="4">
          <v-container fluid class="pa-2">
            <v-card>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table :items="summaryTableData" hide-actions hide-headers>
                    <template slot="items" slot-scope="props">
                      <td>
                        <v-icon>{{ props.item.icon }}</v-icon
                        >&nbsp;{{ $t(props.item.i18nTitle) }}
                      </td>
                      <td>
                        <span>{{ props.item.value }}</span>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout v-if="isUsingAdvancedDatesMode" row wrap style="margin-top: 20px">
                <v-flex xs12>
                  <schedule-viewer :weekdays="weekdays" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>

          <v-btn class="btn btn-default btn-fill btn-wd btn-back capitalize" color="grey lighten-1" @click="activeStep = 3" v-html="$t('private_global.button.back')"></v-btn>

          <v-btn @click="changeAvailability" color="primary" class="capitalize" v-html="$t('private_global.button.confirm')"></v-btn>
        </v-stepper-content>
      </v-stepper>
      <v-alert v-if="errorMessage" outline color="error" icon="priority_high" :value="true">
        {{ errorMessage }}
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import keys from '@/store/keys';
import moment from 'moment';
import _ from 'lodash';
import SpotsMultipleSelect from '@/components/commons/SpotsMultipleSelect.vue';
import ScheduleConfigurator from '@/components/commons/ScheduleConfigurator.vue';
import ScheduleViewer from '@/components/commons/ScheduleViewer.vue';
import availabilityService from '@/services/availabilityService';
import { EventBus } from '@/services/eventBus';
import VuetifyFromToDateSelector from '@/components/commons/VuetifyFromToDateSelector.vue';

const onCloseModalEvent = 'on-close-modal';

export default {
  name: 'update-availabilities-modal',
  components: {
    [SpotsMultipleSelect.name]: SpotsMultipleSelect,
    [ScheduleConfigurator.name]: ScheduleConfigurator,
    [ScheduleViewer.name]: ScheduleViewer,
    [VuetifyFromToDateSelector.name]: VuetifyFromToDateSelector
  },
  props: ['isSensored', 'isAvailabilityDialogVisible', 'parkingId'],
  watch: {
    advanced: function(newValue) {
      if (newValue) {
        setTimeout(() => {
          if (typeof this.$refs.scheduleConfigurator !== 'undefined') {
            this.$refs.scheduleConfigurator.updateWeekdaysSelected(this.datesAvailabilityAdvanced);
          }
        }, 300);
      }
    },
    datesAvailabilityBasic: function(newValue) {
      if (newValue === null) {
        this.datesAvailabilityBasic = [];
      }
      this.updateStepMessage();
    },
    spotsToModify: function(newValue) {
      this.updateStepMessage();
    },
    actionAvailability: function(newValue) {
      this.updateStepMessage();
    },
    spotsAmountSensorless: function(newValue) {
      this.updateStepMessage();
    },
    weekdays: function(newValue) {
      this.updateStepMessage();
    }
  },
  data() {
    return {
      errorMessage: null,
      isValidStep2: true,
      isValidStep3: true,
      showCalendarTooltip: false,
      activeStep: 0,
      isUsingAdvancedDatesMode: false,
      parkingName: '',
      hasAggressiveRecolocation: false,
      datesAvailabilityAdvanced: [],
      datesAvailabilityBasic: [],
      store: store,
      pickerOptions: {
        firstDayOfWeek: 7,
        disabledDate(time) {
          let diffDay = moment.range(Date.now(), time).diff('day');
          return diffDay < 0;
        }
      },
      actionAvailability: 'add',
      weekdays: [],
      spotsToModify: [],
      spotsAmountSensorless: 0,
      stepsMessage: '',
      stepsStyleMessage: 'warning',
      hasDateErrors: true,
      hasSpotErrors: true,
      summaryTableData: [
        {
          icon: 'mdi-calendar',
          i18nTitle: 'private_availability_modal_actions_summary_period',
          value: ''
        },
        {
          icon: 'mdi-car-side',
          i18nTitle: 'private_availability_modal_actions_summary_period',
          value: ''
        },
        {
          icon: 'ti-layout',
          i18nTitle: 'private_availability_modal_actions_summary_period',
          value: ''
        }
      ],
      langSelected: store.state.langSelected
    };
  },
  created() {
    this.init();
    this.parkingName = store.state.parkingSelected.name;
    this.hasAggressiveRecolocation = store.state.parkingSelected.hasAggressiveRecolocation;
    EventBus.$on(keys.eventOnLanguageChanged, this.updateStepMessage);

    this.pickerOptions.firstDayOfWeek = store.state.langSelected.firstDayOfWeek;
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateStepMessage);
  },
  methods: {
    handleErrorMessage(errorMessage) {
      if (errorMessage != null) {
        this.errorMessage = this.stepsMessage;
      }
    },
    validateSecondStep() {
      if (!this.validatePayloadAvailabilities(false)) {
        if (this.hasDateErrors) {
          this.isValidStep2 = false;
          this.errorMessage = this.stepsMessage;
          return;
        }
      }
      if (typeof this.$refs.spotsMultipleSelect !== 'undefined') {
        this.$refs.spotsMultipleSelect.reloadSpots();
      }
      this.isValidStep2 = true;
      this.errorMessage = null;
      this.activeStep = 3;
    },
    validateThirdStep() {
      if (!this.validatePayloadAvailabilities(false)) {
        if (this.hasSpotErrors) {
          this.isValidStep3 = false;
          this.errorMessage = this.stepsMessage;
          return;
        }
      }
      this.isValidStep3 = true;
      this.errorMessage = null;
      this.activeStep = 4;
    },
    onChangeBasicAdvancedDatesTab() {
      this.updateStepMessage();
    },
    updateStepMessage() {
      this.pickerOptions.firstDayOfWeek = store.state.langSelected.firstDayOfWeek;

      this.stepsMessage = '';
      if (!this.validatePayloadAvailabilities(false)) {
        this.stepsStyleMessage = 'warning';
        return;
      }

      this.stepsStyleMessage = 'info';

      let scheduleText = '';

      let scheduleArray = [];
      _.each(this.weekdays, itWeekday => {
        if (itWeekday.schedule.length > 0) {
          let scheduleItem = `${itWeekday.label}: `;

          if (itWeekday.schedule[0].isAllDay) {
            scheduleItem += this.$i18n.t('private_modal_availabilities_modify_date_allday');
          } else {
            let ranges = _.map(itWeekday.schedule, itSchedule => {
              let from = moment(itSchedule.range.start).format('HH:mm');
              let to = moment(itSchedule.range.end).format('HH:mm');
              return `${from} - ${to}`;
            });
            scheduleItem += _.join(ranges, ', ');
          }
          scheduleArray.push(scheduleItem);
        }
      });
      scheduleText = _.join(scheduleArray, ', ');

      if (this.isSensored) {
        this.setStepMessageSensored(scheduleText);
      } else {
        this.setStepMessageSensorless(scheduleText);
      }
    },
    init() {
      if (typeof this.$refs.formWizard !== 'undefined') {
        this.$refs.formWizard.reset();
      }

      this.actionAvailability = 'add';
      this.activeStep = 1;
      this.isUsingAdvancedDatesMode = false;
      this.weekdays = [];
      this.spotsToModify = [];
      this.datesAvailabilityBasic = [];
      this.datesAvailabilityAdvanced = [];
      this.spotsAmountSensorless = 0;
      this.hasDateErrors = true;
      this.hasSpotErrors = true;
    },
    getDatesAvailabilityBasicIndexSimpleFormat(index) {
      return `${moment(this.datesAvailabilityBasic[index]).format('L HH:mm')}`;
    },
    getDatesAvailabilityAdvancedIndexSimpleFormat(index) {
      return `${moment(this.datesAvailabilityAdvanced[index]).format('L')}`;
    },
    updateSummaryTable(period, spots, actionText) {
      this.summaryTableData = [];
      this.summaryTableData.push({
        icon: 'mdi-calendar',
        i18nTitle: 'private_availability_modal_actions_summary_period',
        value: period
      });

      if (spots !== null) {
        this.summaryTableData.push({
          icon: 'mdi-car-side',
          i18nTitle: 'private_availability_modal_actions_summary_spots',
          value: spots
        });
      }

      this.summaryTableData.push({
        icon: 'mdi-flash-outline',
        i18nTitle: 'private_parking_products_table_actions',
        value: this.$i18n.t(actionText)
      });
    },
    setStepMessageSensorless(scheduleText) {
      let from = this.getDatesAvailabilityBasicIndexSimpleFormat(0);
      let to = this.getDatesAvailabilityBasicIndexSimpleFormat(1);

      let period = `${from} - ${to}`;
      let amount = this.spotsAmountSensorless;
      let i18nMessage = 'private_availability_modal_message_basic_sensorless';

      if (this.isUsingAdvancedDatesMode) {
        from = this.getDatesAvailabilityAdvancedIndexSimpleFormat(0);
        to = this.getDatesAvailabilityAdvancedIndexSimpleFormat(1);
        i18nMessage = 'private_availability_modal_message_advanced_sensorless';
        period = `${from} - ${to}`;
      }

      this.stepsMessage = this.$i18n.t(i18nMessage, {
        amount: amount,
        from: from,
        to: to,
        schedule: scheduleText
      });

      this.updateSummaryTable(period, amount, 'private_availabilities_button_modify');
    },
    setStepMessageSensored(scheduleText) {
      let action = this.actionAvailability === 'add' ? this.$i18n.t('private_availability_modal_messsage_add') : this.$i18n.t('private_availability_modal_messsage_remove');
      let actionI18N = this.actionAvailability === 'add' ? 'private_availability_modal_messsage_add' : 'private_availability_modal_messsage_remove';
      let spots = store.state.parkingSpots;

      let spotsName = _.chain(spots)
        .filter(itSpot => {
          let exists = _.find(this.spotsToModify, itSpotsToModify => {
            return itSpotsToModify === itSpot.id;
          });
          return typeof exists !== 'undefined';
        })
        .map('label')
        .join(',')
        .value();

      let from = this.getDatesAvailabilityBasicIndexSimpleFormat(0);
      let to = this.getDatesAvailabilityBasicIndexSimpleFormat(1);
      let i18nMessage = 'private_availability_modal_message_basic_sensored';

      if (this.isUsingAdvancedDatesMode) {
        i18nMessage = 'private_availability_modal_message_advanced_sensored';
        from = this.getDatesAvailabilityAdvancedIndexSimpleFormat(0);
        to = this.getDatesAvailabilityAdvancedIndexSimpleFormat(1);
      }

      this.stepsMessage = this.$i18n.t(i18nMessage, {
        action: action,
        spots: spotsName,
        from: from,
        to: to,
        schedule: scheduleText
      });

      let period = `${from} - ${to}`;

      this.updateSummaryTable(period, spotsName, actionI18N);
    },
    changeAvailability() {
      if (!this.validatePayloadAvailabilities(true)) {
        return;
      }

      if (!this.isUsingAdvancedDatesMode) {
        this.changeAvailabilityBasic();
      } else {
        this.changeAvailabilityAdvanced();
      }

      this.innerCloseModal();
    },
    getDatesAvailabilityBasicIndexUtcFormat(index) {
      return `${moment(this.datesAvailabilityBasic[index]).format('YYYY-MM-DD[T]HH:mm:ss[Z]')}`;
    },
    changeAvailabilityBasic() {
      let amount = this.spotsAmountSensorless;

      if (this.isSensored) {
        amount = this.actionAvailability === 'add' ? 1 : 0;
      }

      let params = {
        parking: this.parkingId,
        start: this.getDatesAvailabilityBasicIndexUtcFormat(0),
        end: this.getDatesAvailabilityBasicIndexUtcFormat(1),
        amount: amount,
        spots: this.spotsToModify
      };

      availabilityService.change(params, this.changeAvailabilitySuccessHandler, this.changeAvailabilityErrorHandler);
    },
    changeAvailabilityAdvanced() {
      let schedule = this.mapWeekdaysToSendToServer();

      let amount = this.spotsAmountSensorless;

      if (this.isSensored) {
        amount = this.actionAvailability === 'add' ? 1 : 0;
      }

      let params = {
        parking: this.parkingId,
        start: moment(this.datesAvailabilityAdvanced[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.datesAvailabilityAdvanced[1])
          .add(1, 'day')
          .format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        amount: amount,
        spots: this.spotsToModify,
        schedule: JSON.stringify(schedule),
        relocateNextReservations: false
      };

      availabilityService.changeBulk(params, this.changeAvailabilitySuccessHandler, this.changeAvailabilityErrorHandler);
    },
    changeAvailabilitySuccessHandler(data) {
      if (data.blocked === true) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'private_availabilities_edit_warning_message',
          type: 'warning'
        });
      } else {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'private_availabilities_edit_info_message',
          type: 'info'
        });

        EventBus.$emit(keys.eventOnParkingAvailabilitiesUpdated, {});
      }
    },
    changeAvailabilityErrorHandler() {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: 'private_availability_modal_general_error_availabilites',
        type: 'error'
      });
    },
    isParkingUpdatingAvailabilitiesErrorHandler() {},
    validatePayloadAvailabilities(showNotifications) {
      let isValid = true;

      this.hasDateErrors = false;
      this.hasSpotErrors = false;

      if (this.isUsingAdvancedDatesMode) {
        isValid = this.validateAdvancedOptions(showNotifications);
      } else {
        isValid = this.validateBasicOptions(showNotifications);
      }

      if (!isValid) {
        this.hasDateErrors = true;
      }

      if (this.isSensored) {
        if (this.spotsToModify.length === 0) {
          if (isValid) {
            this.stepsMessage = this.$i18n.t('private_form_error_spots_option');
            if (showNotifications) {
              EventBus.$emit(keys.eventOnShowNotification, {
                title: '',
                message: this.$i18n.t('private_form_error_spots_option'),
                type: 'warning',
                doNotTranslate: true
              });
            }
          }

          isValid = false;

          this.hasSpotErrors = true;
        }
      }

      return isValid;
    },
    validateAdvancedOptions(showNotifications) {
      if (this.datesAvailabilityAdvanced.length === 0) {
        this.stepsMessage = this.$i18n.t('private_form_error_date_option');

        if (showNotifications) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: this.$i18n.t('private_form_error_date_option'),
            type: 'warning',
            doNotTranslate: true
          });
        }
        return false;
      }

      if (this.weekdays.length === 0) {
        this.stepsMessage = this.$i18n.t('private_form_error_schedule_option');

        if (showNotifications) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: this.stepsMessage,
            type: 'warning',
            doNotTranslate: true
          });
        }
        return false;
      } else {
        let weekdayHasSchedule = _.sumBy(this.weekdays, weekday => {
          return weekday.schedule.length;
        });
        if (weekdayHasSchedule === 0) {
          this.stepsMessage = this.$i18n.t('private_form_error_schedule_option');
          if (showNotifications) {
            EventBus.$emit(keys.eventOnShowNotification, {
              title: '',
              message: this.stepsMessage,
              type: 'warning',
              doNotTranslate: true
            });
          }
          return false;
        }
      }
      return true;
    },
    validateBasicOptions(showNotifications) {
      if (this.datesAvailabilityBasic.length === 0) {
        this.stepsMessage = this.$i18n.t('private_form_error_date_option');
        if (showNotifications) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: this.$i18n.t('private_form_error_date_option'),
            type: 'warning',
            doNotTranslate: true
          });
        }

        return false;
      }
      return true;
    },
    innerCloseModal() {
      if (typeof this.$refs.scheduleConfigurator !== 'undefined') {
        this.$refs.scheduleConfigurator.init();
      }
      if (this.isSensored) {
        this.$refs.spotsMultipleSelect.init();
      }
      this.$emit(onCloseModalEvent);
      this.init();
    },
    onWeekdayChanged(weekdays) {
      this.weekdays = weekdays;
      this.updateStepMessage();
    },
    mapWeekdaysToSendToServer() {
      let schedule = {
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: [],
        sun: [],
        isMonAllDay: false,
        isTueAllDay: false,
        isWedAllDay: false,
        isThuAllDay: false,
        isFriAllDay: false,
        isSatAllDay: false,
        isSunAllDay: false
      };

      _.each(this.weekdays, function(wd, index) {
        var schedRes = [];
        var isAllDay = false;
        _.each(wd.schedule, function(d) {
          isAllDay = d.isAllDay;
          schedRes.push(moment(d.range.start).format('HH:mm') + '-' + moment(d.range.end).format('HH:mm'));
        });
        if (wd.id === 1) {
          schedule.mon = schedRes;
          schedule.isMonAllDay = isAllDay;
        } else if (wd.id === 2) {
          schedule.tue = schedRes;
          schedule.isTueAllDay = isAllDay;
        } else if (wd.id === 3) {
          schedule.wed = schedRes;
          schedule.isWedAllDay = isAllDay;
        } else if (wd.id === 4) {
          schedule.thu = schedRes;
          schedule.isThuAllDay = isAllDay;
        } else if (wd.id === 5) {
          schedule.fri = schedRes;
          schedule.isFriAllDay = isAllDay;
        } else if (wd.id === 6) {
          schedule.sat = schedRes;
          schedule.isSatAllDay = isAllDay;
        } else if (wd.id === 7) {
          schedule.sun = schedRes;
          schedule.isSunAllDay = isAllDay;
        }
      });

      return schedule;
    },
    onSpotsChanged(spotsToModify) {
      this.spotsToModify = spotsToModify;
    },

    datesSelected(params) {
      this.datesAvailabilityAdvanced = [params.start, params.end];

      if (this.isUsingAdvancedDatesMode) {
        if (typeof this.$refs.scheduleConfigurator !== 'undefined') {
          this.$refs.scheduleConfigurator.updateWeekdaysSelected(this.datesAvailabilityAdvanced);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}

.el-alert,
.el-tabs,
.el-row,
.el-card {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.collapse-title {
  margin-left: 15px;
}

.el-date-editor--time-select {
  width: 174px;
}

.el-xs-size {
  width: 300px;
}

-el-big-size {
  width: 468px;
}
</style>

<style lang="scss">
.alert-message {
  span,
  i {
    font-size: 25px !important;
    line-height: 30px !important;
  }
}

.el-collapse-item__header {
  background: #fafafa;
}

.el-transfer-panel {
  width: 300px;
}

.el-dialog__body {
  padding: 0px 20px !important;
}

.wizard-header {
  display: none;
}

.wizard-card-footer {
  padding: 20px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/UpdateAvailabilitiesModal.vue